// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2r-6";
export var headerCell = "_2r-2";
export var loadingStateContent = "_2r-8";
export var rowWrapper = "_2r-4";
export var stickyAggregationCell = "_2r-b";
export var stickyAggregationRow = "_2r-7";
export var stickyColumnCell = "_2r-a";
export var stickyColumnHeaderCell = "_2r-9";
export var table = "_2r-1";
export var virtualRowWrapper = "_2r-5";
export var virtualTableBodyFiller = "_2r-d";
export var virtualTableBodyFillerBottom = "_2r-e";
export var virtualTableContainer = "_2r-0";
export var virtualTableContainerFill = "_2r-c";
export var white = "_2r-3";